<template>
  <div>
    <div class="filter-container" style="border-bottom: 0;margin-bottom: 0;">
      <el-row class="filter-top" type="flex" justify="end">
        <el-col :span="10">
          <slot name="toolbar-left">
            <span class="span-top-text">企业信息</span>
          </slot>
        </el-col>
        <el-col :span="14">
          <div style="text-align: right;">
            <el-button v-if="$permission.canWrite()" class="filter-item" type="primary" @click="edit">编辑</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-form class="info-content">
      <el-row>
        <el-col :span="12">
          <el-form-item label="企业名称">
            <span>{{data.EntName}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="企业性质">
            <span v-if="data.Nature==0">国有企业</span>
            <span v-if="data.Nature==1">事业单位</span>
            <span v-else-if="data.Nature==2">集体所有制企业</span>
            <span v-else-if="data.Nature==3">联营企业</span>
            <span v-else-if="data.Nature==4">三资企业</span>
            <span v-else>私营企业</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系电话">
            <span>{{data.Phone}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="企业法人">
            <span>{{data.Legal}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="企业地址">
            <span>{{data.Address}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider content-position="left">企业Logo</el-divider>
      <el-row>
        <el-col :span="24" style="padding:0px 20px;">
          <span v-if="!data.Logo" style="font-size:14px;">无</span>
          <el-image
            v-else
            style="height:150px;width:150px;"
            :src="'/api'+data.Logo"
            fit="scale-down"
            :preview-src-list="['/api'+data.Logo]"
          />
        </el-col>
      </el-row>
      <el-divider content-position="left">企业简介</el-divider>
      <el-row>
        <el-col :span="24" style="padding:0px 20px;">
          <div v-html="data.Intro"></div>
        </el-col>
      </el-row>
      <el-divider content-position="left">资质荣誉</el-divider>
      <el-row>
        <el-col :span="24" style="padding:0px 20px;">
          <div v-html="data.Honer"></div>
        </el-col>
      </el-row>
      <el-divider content-position="left">饲养环境</el-divider>
      <el-row>
        <el-col :span="24" style="padding:0px 20px;">
          <div v-html="data.Environment"></div>
        </el-col>
      </el-row>
      <el-divider content-position="left">饲养过程</el-divider>
      <el-row>
        <el-col :span="24" style="padding:0px 20px;">
          <div v-html="data.Process"></div>
        </el-col>
      </el-row>
    </el-form>
    <edit-dialog ref="editDialog" @close-saved="getData"></edit-dialog>
  </div>
</template>
<script>
import editDialog from "./editDialog";

export default {
  components: {
    editDialog,
  },
  data() {
    return {
      data: {
        EntId: 0,
        EntName: "",
        Nature: null,
        Phone: "",
        Legal: "",
        Address: "",
        Logo: "",
        Intro: "", //简介
        Honer: "", //资质荣誉
        Environment: "", //饲养环境
        Process: "", //饲养过程
      },
      api: require("@/api/ent/ent").default,
    };
  },
  methods: {
    getData() {
      this.api.getMyInfo().then((res) => {
        this.data = res.Data;
        console.log(this.data.Logo, "logo");
      });
    },
    edit() {
      this.$refs.editDialog.openEdit(this.data);
    },
  },
};
</script>
<style lang='less' scoped>
.info-content {
  padding: 10px 15px;
  border: 1px solid #ebeef5;
}

.el-form-item {
  margin-bottom: 0;
}
</style>